import { useEffect } from "react";
import { useSelector } from "react-redux";
import ChangeLog from "./ChangeLog";
import purchaseOrderSelectors from "../../../../../redux/PurchaseOrder/selectors";
import  ApproverColumns from "../../../../utils/changeLogColumns"

const ChangeLogContainer = (props?: any) => {
  const skipVendorDetail = props?.skipVendorDetail
  const setCancelledItemFleetId = props?.setCancelledItemFleetId;

  const { changeLogs }: any = useSelector((state: any) => ({
    changeLogs: purchaseOrderSelectors.getChangeLogs(state),
  }));

  useEffect(() => {
    setCancelledItemFleetId(0)
  }, [changeLogs])

  return (
    <ChangeLog
      Data={changeLogs[props?.fleetRequestDetailId]}
      ApproverColumns={ApproverColumns}
      activeStepper={props?.activeStepper}
      skipVendorDetail={skipVendorDetail}
    />
  );
};
export default ChangeLogContainer;
